import { createAPIService } from './api.service';

export const EMPLOYEES_ADMIN_ENDPOINT = '/employee/api/v1/admin/employees';

const service = createAPIService(EMPLOYEES_ADMIN_ENDPOINT);

service.createEmployee = async employee =>
  (await service.post('', employee)).data;

service.updateEmployee = async (id, employee) =>
  (await service.patch(`/${id}`, employee)).data;

export default service;
